import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a5f4d9e99f1da0014676987_1785025142026_6f6f7e08/examplatform/src/app/student-login/components/StudentLoginScreen.tsx");
